import React from "react";
import { TCText } from "../../../components/TCText/TCText";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { Colors } from "../../../utils/colors";
import { TeamScore } from "../../../stores/matchDetails/MatchDetailsStore";

type props = {
  isCurrentUserTeam?: boolean;
  team?: TeamScore;
};

export const TeamPlayerScore: React.FC<props> = ({
  isCurrentUserTeam,
  team,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 10,
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          gap: 8,
        }}>
        <UserAvatar
          avatar={{
            image: team?.playerA.playerImageUrl ?? "",
            name: team?.playerA.playerName ?? "",
          }}
          size={32}
        />
        <UserAvatar
          avatar={{
            image: team?.playerB.playerImageUrl ?? "",
            name: team?.playerB.playerName ?? "",
          }}
          size={32}
          style={{ marginLeft: -10 }}
        />
        <div>
          <TCText
            value={team?.playerA.playerName ?? ""}
            numberOfLines={1}
            style={{
              fontSize: 10,
              fontWeight: isCurrentUserTeam ? 600 : 500,
              color: isCurrentUserTeam ? Colors.green : Colors.grey,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
          <TCText
            value={team?.playerB.playerName ?? ""}
            style={{
              fontSize: 10,
              fontWeight: isCurrentUserTeam ? 600 : 500,
              color: isCurrentUserTeam ? Colors.green : Colors.grey,
              marginTop: -3,
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flex: 1,
          justifyContent: "space-around",
        }}>
        {team?.scores?.map((score) => (
          <div
            style={{
              height: 32,
              width: 32,
              borderRadius: 10,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(133, 131, 131, 0.1)",
              display: "flex",
            }}>
            <TCText
              value={score?.score?.toString() ?? ""}
              style={{ fontWeight: 600, fontSize: 16, color: Colors.green }}
            />
          </div>
        ))}
        <div
          style={{
            height: 32,
            width: 32,
            borderRadius: 10,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: Colors.success,
            display: "flex",
          }}>
          <TCText
            value={team?.noOfSetsWon?.toString() ?? ""}
            style={{ fontWeight: 600, fontSize: 16, color: Colors.white }}
          />
        </div>
      </div>
    </div>
  );
};
